// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10X8e","left":"styles_left__37G0O","right":"styles_right__3J4Oe","alert":"styles_alert__3cj3a"};